import Circle_Write from '../../components/ExcerciseTypes/Circle_Write'
import T6 from '../../components/ExcerciseTypes/TypeIn/T6'
import UI from '../../components/ExcerciseTypes/Design/UserInterface'
const json = {
	1: {
		// Exercise num
		unit: 'Stater',
		id: '4WB-S-P4-E1',
		audio: '',
		component: T6,
		exerciseKey: 'img/FriendsPlus/Page4/E1/Key/E1answerKey.png',
		// exerciseKey: 'img/FriendsPlus/Page39/Key/E2answerKey.png',
		inputSize: 130,
		textAlign: 'center',
		maxLength: 8,
		stylesTextInput: {
			background: 'none',
			// borderBottom: "none",
			fontSize: 22,
			height: 27,
			// textTransform: 'uppercase',
		},

		titleQuestion: [
			{
				num: '1',
				title: 'Write.',
				color: '#234090',
			},
		],
		hintBox: [
			{
				src: [
					'Tim',
					'brown',
					'straight',
					'short',
					'<s>Roxy</s>',
					'green',
					'curly',
					'Billy',
				],
				width: 900,
				borderColor: 'rgb(8 177 239)',
				bgColor: 'none',
				fontSize: 23,
			},
		],
		questions: [
			{
				title: `
        <hintbox id='0'></hintbox>
        <div style='position: relative; display:flex;margin-top:20px; line-height:37px; font-size: 22px' >
          <img style="width:3.5cm; height: 3.5cm"   src="img/FriendsPlus/Page4/E1/1.jpg" />
          <div >
            Her name’s <u style='color:gray ' >&ensp;Rosy&ensp;</u> <br> She has#hair.<br> She#has eyes.
          </div>
        </div>
        <div style='display:flex;margin:20px 0px; line-height:37px; font-size: 22px' >
          <img style="width:3.5cm; height: 3.5cm"  src="img/FriendsPlus/Page4/E1/2.jpg" />
          <div >
            His name’s#.<br>
            He’s Rosy’s cousin.<br>
            He has#hair.<br>
            He has#eyes.<br>
          </div>
        </div>
        <div style='display:flex; line-height:37px; font-size: 22px' >
          <img style="width:3.5cm; height: 3.5cm"  src="img/FriendsPlus/Page4/E1/3.jpg" />
          <div >
            His name’s#.<br>
            He’s Rosy’s brother.<br>
            He has#hair.
          </div>
        </div>
            
          `,
				answer: [
					'straight',
					'brown',
					'Tim',
					'short',
					'green',
					'Billy',
					'curly',
				],
			},
		],
	},
	2: {
		unit: 'Stater',
		id: '4WB-S-P4-E2',
		audio: '',
		video: '',
		component: T6,
		stylesTextInput: { borderBottom: 'dotted' },
		inputSize: 410,
		maxLength: 34,
		// exerciseKey: 'img/FriendsPlus/Page58/Key/E1answerKey.png',
		// exerciseKey: "img/FriendsPlus/Page46/Key/E3answerKey.png",
		checkUppercase: true,
		titleQuestion: [
			{
				num: '2',
				title: 'Find and circle the family words.  ',
				color: '#234090',
			},
		],
		questionImage: [
			[
				{
					url: 'img/FriendsPlus/Page4/E2/1.jpg',
				},
			],
		],
	},
}
export default json
